// extracted by mini-css-extract-plugin
export var brandColor = "#846d3d";
export var mainColor = "#2f4758";
export var subColor = "#c0d1dd";
export var lightColor = "#f4f6f8";
export var greyColor = "#707070";
export var darkColor = "#363636";
export var subscriptionColor = "#65c79b";
export var orderColor = "#298df3";
export var errorColor = "#fd3894";
export var frontlineColor = "#e08912";
export var categoryFoodColor = "#e08912";
export var categoryDogHealthColor = "#298df3";
export var categoryTrainingColor = "#65c79b";
export var categoryLifestyleColor = "#fd3188";
export var footer = "styles-module--footer--3oPs-";
export var footer__border = "styles-module--footer__border--3sN39";
export var footer__body = "styles-module--footer__body--suFsL";
export var footer__links = "styles-module--footer__links--UAQvG";
export var footer__icons = "styles-module--footer__icons--2NrNu";